export default __webpack_public_path__ + "static/Nunito-Bold-275dd55e10ba966bcb9b3bc4e3643548.ttf";